export default __webpack_public_path__ + "static/media/dollar_sign.36d3c5de.svg";